import React from 'react';
import {useQuery} from "@tanstack/react-query";

const API_URL = import.meta.env.VITE_API_URL;
const ImageCellRenderer = ({data}) => {
    const {id} = data;

    const { data: imageUrl } = useQuery({
        queryKey: ['image', id],
        queryFn: async () => {
            const res = await fetch(`${API_URL}/user/getImage/${id}`);
            const blob = await res.blob();
            return URL.createObjectURL(blob);
        },
        staleTime: Infinity,
        cacheTime: Infinity,
    });

    return (
        <div className="py-1 bg-white border border-[#e0e0e0] rounded shadow-sm h-full [align-content:center]">
            { imageUrl && <img src={imageUrl} alt="" loading="lazy"/> }
        </div>
    );
};

export default ImageCellRenderer;